import { Component, ViewEncapsulation, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

import { NumberPipe } from '../../../../shared/pipes/number.pipe';

interface Data {
	showIcon: boolean;
	unit: string;
}

@Component({
	selector: 'copo-needs-icon-cell',
	templateUrl: './needs-icon-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatIconModule, NumberPipe]
})
export class NeedsIconCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;
	icon?: string = 'red';
	params?: ICellRendererParams<Data, string | number>;
	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<Data, string | number>) {
		this.params = params;
	}

	refresh(params: ICellRendererParams<Data, string | number>) {
		this.params = params;
		return true;
	}

	isNumber(val: string | number | null | undefined): val is number {
		return typeof val === 'number';
	}

	isString(val: string | number | null | undefined): val is string {
		return typeof val === 'string';
	}
}
